import { render } from "./AddtoCart.vue?vue&type=template&id=96ad834c&scoped=true"
import script from "./AddtoCart.vue?vue&type=script&lang=js"
export * from "./AddtoCart.vue?vue&type=script&lang=js"

import "./AddtoCart.vue?vue&type=style&index=0&id=96ad834c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96ad834c"]])

export default __exports__